export default function getResource(label, vars = []) {
    const resources = {
        email: 'Adresse courriel',
        edit: 'Modifier',
        confirmEmailLabel: 'Confirmer l’adresse courriel',
        cancel: 'Annuler',
        update: 'Mise à jour',
        emptyEmailMessage: 'Veuillez remplir ce champ.',
        invalidConfirmationMessage: 'L’adresse courriel saisie ne correspond pas. Veuillez corriger pour continuer.',
        invalidEmailMessage: 'Veuillez saisir une adresse courriel au format nomutilisateur@domaine.com.',
        invalidEmailError: 'Type d’adresse courriel non valide. Veuillez entrer une adresse courriel valide',
        warningTextTitle: 'Are you sure?',
        warningPasskeyText1: 'Changing your email address will also remove all passkeys currently linked to your Sephora account.',
        warningPasskeyText2: 'After the change, you can easily set up new passkeys to keep enjoying fast, seamless sign‑in.',
        warningPasskeyText3: 'Would you like to continue?',
        continue: 'Continue'
    };
    return resources[label];
}
